module.exports = __webpack_public_path__ + "static/media/vijayratna.84dc1a5a.png";